// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3RbVU","dragIcon":"SortableItem_dragIcon__bR5aP","disabled":"SortableItem_disabled__Z5F5E"};